export const DAMAGE_CASE_ADD_PICTURE = "DAMAGE_CASE_ADD_PICTURE"
export const DAMAGE_CASE_DELETE_PICTURE = "DAMAGE_CASE_DELETE_PICTURE"
export const DAMAGE_CASE_SHOW_SCREEN = "DAMAGE_CASE_SHOW_SCREEN"
export const DAMAGE_CASE_START_CASE = "DAMAGE_CASE_START_CASE"
export const DAMAGE_CASE_ADD_CASE = "DAMAGE_CASE_ADD_CASE"
export const DAMAGE_CASE_TOGGLE_COPY_TO = "DAMAGE_CASE_TOGGLE_COPY_TO"
export const DAMAGE_CASE_TOGGLE_TRADE = "DAMAGE_CASE_TOGGLE_TRADE"
export const DAMAGE_CASE_REMEMBER_ATTRIBUTE = "DAMAGE_CASE_REMEMBER_ATTRIBUTE"
export const DAMAGE_CASE_REMEMBER_DRAWING = "DAMAGE_CASE_REMEMBER_DRAWING"
export const DAMAGE_CASE_DISCARD_CASE = "DAMAGE_CASE_DISCARD_CASE"
export const DAMAGE_CASE_REMOVE_CASE = "DAMAGE_CASE_REMOVE_CASE"
export const DAMAGE_CASE_SUBMIT_CASE_BEGIN = "DAMAGE_CASE_SUBMIT_CASE_BEGIN"
export const DAMAGE_CASE_SUBMIT_CASE_SUCCESS = "DAMAGE_CASE_SUBMIT_CASE_SUCCESS"
export const DAMAGE_CASE_SUBMIT_CASE_FAILURE = "DAMAGE_CASE_SUBMIT_CASE_FAILURE"
export const DAMAGE_CASE_SUBMIT_CASE_DISMISS_ERROR = "DAMAGE_CASE_SUBMIT_CASE_DISMISS_ERROR"



// WEBPACK FOOTER //
// ./src/features/damage-case/redux/constants.js